import { css, Global } from "@emotion/react";
import React from "react";

const GlobalStyles = ({ backgroundcolor, textColor, zIndex = 2100 }) => {
  const globalStyles = css`
    .MuiTooltip-tooltip {
      background-color: ${backgroundcolor} !important;
      color: ${textColor} !important;
    }
    .MuiTooltip-popper {
      z-index: ${zIndex} !important;
    }
  `;

  return <Global styles={globalStyles} />;
};

const SC = {
  GlobalStyles,
};

export default SC;
